import { render, staticRenderFns } from "./CourseSupportDataTable.vue?vue&type=template&id=7a48e99a&scoped=true"
import script from "./CourseSupportDataTable.vue?vue&type=script&lang=js"
export * from "./CourseSupportDataTable.vue?vue&type=script&lang=js"
import style0 from "./CourseSupportDataTable.vue?vue&type=style&index=0&id=7a48e99a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a48e99a",
  null
  
)

export default component.exports